/**
 * i18n 初始化 — react-i18next
 * MVP 只有中文，v2 加英文零成本（加一个 en.json + 切换逻辑）
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './locales/zh.json';

i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
  },
  lng: 'zh', // MVP 固定中文
  fallbackLng: 'zh',
  interpolation: {
    escapeValue: false, // React 已防 XSS
  },
});

export default i18n;
